<template>
    <div class="footer">
        <span class="title">
            2022 © Tag&Match
        </span>
        <div class="social-icons">
            <a v-for="item in icons"
               target="_blank"
               :href="item.link"
               :aria-label="item.title"
               v-html="item.icon"
               class="icon" >
            </a>
        </div>
        <div class="right">
            <div @click="showPopUp(terms)" class="item">{{fn.tr('terms & conditions')}}</div>
            <div @click="showPopUp(privacy)" class="item">{{fn.tr('Privacy Policy')}}</div>
        </div>
    </div>
</template>


<script>
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            terms: {
                id: 'Terms',
                // color: '#0D1321'
            },
            privacy: {
                id: 'Privacy',
                // color: '#0D1321'
            },
        }
    },
    computed: {
        ...mapGetters({
            indx: 'menu/indx'
        }),
        icons() {
            let item = this.indx?.widgets?.social
            return [
                {
                    title:'facebook',
                    link: item?.facebook?.url,
                    icon: '\n' +
                        '<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<g clip-path="url(#clip0_239_8702)">\n' +
                        '<path d="M19.2669 10.5C19.2669 5.0896 15.0496 0.703613 9.84734 0.703613C4.64503 0.703613 0.427734 5.0896 0.427734 10.5C0.427734 15.3896 3.87233 19.4425 8.37552 20.1774V13.3318H5.98383V10.5H8.37552V8.34173C8.37552 5.88651 9.78184 4.53033 11.9334 4.53033C12.9637 4.53033 14.042 4.72166 14.042 4.72166V7.13249H12.8542C11.6842 7.13249 11.3191 7.88769 11.3191 8.66318V10.5H13.9316L13.514 13.3318H11.3191V20.1774C15.8223 19.4425 19.2669 15.3896 19.2669 10.5Z" fill="#E6E7E8"/>\n' +
                        '</g>\n' +
                        '<defs>\n' +
                        '<clipPath id="clip0_239_8702">\n' +
                        '<rect width="18.8392" height="19.5928" fill="white" transform="translate(0.427734 0.703613)"/>\n' +
                        '</clipPath>\n' +
                        '</defs>\n' +
                        '</svg>\n'
                },
                {
                    title:'linkedin',
                    link: item?.twitter?.url,
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="white" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>'
                },
                {
                    title:'instagram',
                    link: item?.instagram?.url,
                    icon: '\n' +
                        '<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<path d="M10.1167 2.46773C12.7342 2.46773 13.0441 2.47921 14.0735 2.52513C15.0302 2.56722 15.5468 2.72794 15.8912 2.86188C16.3466 3.03791 16.6757 3.2522 17.0163 3.59278C17.3607 3.93719 17.5711 4.26246 17.7472 4.71784C17.8811 5.06224 18.0418 5.58267 18.0839 6.53552C18.1298 7.56874 18.1413 7.8787 18.1413 10.4923C18.1413 13.1098 18.1298 13.4198 18.0839 14.4492C18.0418 15.4058 17.8811 15.9225 17.7472 16.2669C17.5711 16.7222 17.3568 17.0513 17.0163 17.3919C16.6719 17.7363 16.3466 17.9468 15.8912 18.1228C15.5468 18.2567 15.0264 18.4175 14.0735 18.4596C13.0403 18.5055 12.7303 18.517 10.1167 18.517C7.49923 18.517 7.18926 18.5055 6.15988 18.4596C5.2032 18.4175 4.68659 18.2567 4.34219 18.1228C3.88681 17.9468 3.55771 17.7325 3.21713 17.3919C2.87273 17.0475 2.66226 16.7222 2.48623 16.2669C2.3523 15.9225 2.19158 15.402 2.14948 14.4492C2.10356 13.416 2.09208 13.106 2.09208 10.4923C2.09208 7.87487 2.10356 7.56491 2.14948 6.53552C2.19158 5.57885 2.3523 5.06224 2.48623 4.71784C2.66226 4.26246 2.87656 3.93336 3.21713 3.59278C3.56154 3.24838 3.88681 3.03791 4.34219 2.86188C4.68659 2.72794 5.20703 2.56722 6.15988 2.52513C7.18926 2.47921 7.49923 2.46773 10.1167 2.46773ZM10.1167 0.703613C7.45713 0.703613 7.12421 0.715093 6.07952 0.761014C5.03865 0.806935 4.32305 0.97531 3.70313 1.21639C3.05641 1.46896 2.50919 1.80188 1.9658 2.3491C1.41858 2.89249 1.08566 3.43971 0.833092 4.0826C0.592009 4.70636 0.423634 5.41812 0.377713 6.45899C0.331793 7.50751 0.320312 7.84043 0.320312 10.5C0.320312 13.1596 0.331793 13.4925 0.377713 14.5372C0.423634 15.578 0.592009 16.2936 0.833092 16.9136C1.08566 17.5603 1.41858 18.1075 1.9658 18.6509C2.50919 19.1943 3.05641 19.531 3.6993 19.7798C4.32305 20.0209 5.03482 20.1892 6.07569 20.2352C7.12038 20.2811 7.45331 20.2926 10.1129 20.2926C12.7724 20.2926 13.1054 20.2811 14.1501 20.2352C15.1909 20.1892 15.9065 20.0209 16.5264 19.7798C17.1693 19.531 17.7166 19.1943 18.2599 18.6509C18.8033 18.1075 19.1401 17.5603 19.3888 16.9174C19.6299 16.2936 19.7983 15.5819 19.8442 14.541C19.8901 13.4963 19.9016 13.1634 19.9016 10.5038C19.9016 7.84426 19.8901 7.51134 19.8442 6.46664C19.7983 5.42578 19.6299 4.71018 19.3888 4.09025C19.1477 3.43971 18.8148 2.89249 18.2676 2.3491C17.7242 1.80571 17.177 1.46896 16.5341 1.22022C15.9103 0.979137 15.1986 0.810761 14.1577 0.764841C13.1092 0.715093 12.7763 0.703613 10.1167 0.703613Z" fill="#E6E7E8"/>\n' +
                        '<path d="M10.1171 5.46777C7.3389 5.46777 5.08496 7.72171 5.08496 10.4999C5.08496 13.2781 7.3389 15.532 10.1171 15.532C12.8953 15.532 15.1492 13.2781 15.1492 10.4999C15.1492 7.72171 12.8953 5.46777 10.1171 5.46777ZM10.1171 13.7641C8.31471 13.7641 6.8529 12.3023 6.8529 10.4999C6.8529 8.69752 8.31471 7.23571 10.1171 7.23571C11.9195 7.23571 13.3813 8.69752 13.3813 10.4999C13.3813 12.3023 11.9195 13.7641 10.1171 13.7641Z" fill="#E6E7E8"/>\n' +
                        '<path d="M16.5225 5.2688C16.5225 5.91934 15.9944 6.4436 15.3477 6.4436C14.6971 6.4436 14.1729 5.91551 14.1729 5.2688C14.1729 4.61825 14.7009 4.09399 15.3477 4.09399C15.9944 4.09399 16.5225 4.62208 16.5225 5.2688Z" fill="#E6E7E8"/>\n' +
                        '</svg>\n'
                },
            ]
        }
    },
    methods: {
        showPopUp(item) {
            this.$root.$emit('fire_pop_up', {id: item.id, color: item.color})
        }
    }
}
</script>

<style lang="scss" scoped>
.footer {
    padding: 32px 50px;
    background: #192032;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #E6E7E8;
    width: 100%;
    @media only screen and (max-width: 767px) {
        flex-direction: column;
    }

    .title {
        font-style: italic;
        font-weight: 400;
        font-size: 16px;
    }

    .social-icons {
        display: flex;
        align-items: center;
        @media only screen and (max-width: 767px) {
            margin: 15px 0;
        }

        .icon {
            margin-right: 21px;
            cursor: pointer;

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .right {
        display: flex;
        align-items: center;

        .item {
            font-style: italic;
            font-weight: 400;
            font-size: 16px;
            text-align: right;
            text-decoration-line: underline;
            color: #E6E7E8;
            cursor: pointer;

            &:last-child {
                margin-left: 21px;
            }
        }
    }
}
</style>
